<template>
  <v-card id="card-modal-assign-driver" class=" elevation-4">
    <v-card-title class="justify-start py-2 card-modaltitle">
      <div class="pl-4">
        <h3 class="primary--text pl-4">
          {{ $t("components.views.trip.offers.transport_company.modal_form_accept.title") }}
        </h3>
      </div>
      <v-btn depressed text color="primary" class="cont" @click.stop="$emit('closeForm')">
        <v-icon class="mr-1">fa-solid fa-xmark</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container fluid class="pt-0 mt-0">
        <v-stepper v-model="e1" class="elevation-0">
          <v-row>
            <v-col cols="12" class="pt-0 mt-0">
              <v-stepper-header class="elevation-0">
                <v-stepper-step :complete="e1 > 1" step="1">
                  {{
                    $t("components.views.trip.offers.transport_company.modal_form_accept.driver")
                  }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">
                  {{
                    $t("components.views.trip.offers.transport_company.modal_form_accept.vehicle")
                  }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3">
                  {{
                    $t("components.views.trip.offers.transport_company.modal_form_accept.finish")
                  }}
                </v-stepper-step>
              </v-stepper-header>
            </v-col>
          </v-row>
          <v-stepper-items>
            <v-row>
              <v-col cols="12">
                <v-stepper-content step="1" class="py-0">
                  <v-container class="py-8">
                    <v-row class="justify-center mb-4">
                      <v-col cols="12" class="text-center">
                        <h4 class="primary--text">
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.assign_driver"
                            )
                          }}
                        </h4>
                      </v-col>
                    </v-row>
                    <v-form v-model="validTab1" @submit.prevent>
                      <v-row class="justify-center">
                        <v-col cols="10">
                          <SelectAutocomplete ref="driver" v-model="driver" url="/Drivers"
                            :search-input.sync="driverCreate" return-object item-text="identification"
                            item-value="identification" required dense :rules="[
                              required(
                                $t(
                                  'components.views.trip.offers.transport_company.modal_form_accept.number_id'
                                ),
                                1
                              ),
                            ]" prepend-icon="fa-solid fa-id-card" :label="$t(
                              'components.views.trip.offers.transport_company.modal_form_accept.number_id'
                            )
                              " :placeholder="$t(
                                'components.views.trip.offers.transport_company.modal_form_accept.number_id'
                              )
                                " hide-details maxlength="15">
                            <template slot="no-data">
                              <v-list-item @click="loadModalNewDriver()">
                                <v-list-item-title>{{
                                  $t(
                                    "components.views.trip.no_offer_assign.modal_assign.create_new_driver"
                                  )
                                }}</v-list-item-title>
                              </v-list-item>
                            </template>
                          </SelectAutocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="justify-center">
                        <v-col cols="10" class="pt-2 pb-0">
                          <v-text-field v-model="driverNameComputed" required outlined readonly dense hide-details
                            :label="$t(
                              'components.views.trip.offers.transport_company.modal_form_accept.names_last_names'
                            )
                              " :placeholder="$t(
                                'components.views.trip.offers.transport_company.modal_form_accept.names_last_names'
                              )
                                " prepend-icon="fa-solid fa-user" />
                        </v-col>
                      </v-row>
                      <v-row class="justify-center mt-10 mb-2">
                        <v-btn color="primary" @click="e1 = 2" class="ml-4" depressed :disabled="!validTab1">
                          <v-icon small class="mr-1">fa-solid fa-arrow-right</v-icon>
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.next"
                            )
                          }}
                        </v-btn>
                        <v-btn color="grey lighten-1 white--text" class="ml-4" depressed
                          @click.stop="$emit('closeForm')">
                          <v-icon small size="15" class="mr-1"> fa-solid fa-xmark </v-icon>
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.cancel"
                            )
                          }}
                        </v-btn>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-stepper-content>
                <v-stepper-content step="2" class="pa-0">
                  <v-container class="py-8">
                    <v-row class="justify-center mb-4">
                      <v-col cols="12" class="text-center">
                        <h4 class="primary--text">
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.assign_vehicle"
                            )
                          }}
                        </h4>
                      </v-col>
                    </v-row>
                    <v-form v-model="validTab2" @submit.prevent>
                      <v-row class="justify-center">
                        <v-col cols="10">
                          <SelectAutocomplete ref="vehicle" v-model="vehicle" :url="urlVehicle" return-object
                            item-text="licensePlate" item-value="licensePlate" maxlength="10" required dense
                            :search-input.sync="vehicleCreate" :rules="[
                              required(
                                $t(
                                  'components.views.trip.offers.transport_company.modal_form_accept.license_plate'
                                ),
                                1
                              ),
                            ]" prepend-icon="fa-solid fa-truck-moving" :label="$t(
                              'components.views.trip.offers.transport_company.modal_form_accept.license_plate'
                            )
                              " :placeholder="$t(
                                'components.views.trip.offers.transport_company.modal_form_accept.license_plate'
                              )
                                " hide-details>
                            <template slot="no-data">
                              <v-list-item @click="loadModalNewVehicle()">
                                <v-list-item-title>{{
                                  $t(
                                    "components.views.trip.no_offer_assign.modal_assign.create_new_vehicle"
                                  )
                                }}</v-list-item-title>
                              </v-list-item>
                            </template>
                          </SelectAutocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="justify-center">
                        <v-col cols="10" class="pt-2 pb-0">
                          <SelectAutocomplete ref="trailer" v-model="trailer" :data="filteredTrailers" :init="false"
                            return-object item-text="licensePlate" :search-input.sync="trailerCreate" maxlength="10"
                            dense item-value="licensePlate" prepend-icon="fa-solid fa-trailer" :label="$t(
                              'components.views.trip.offers.transport_company.modal_form_accept.trailer_plate'
                            )
                              " :placeholder="$t(
                                'components.views.trip.offers.transport_company.modal_form_accept.trailer_plate'
                              )
                                " hide-details clearable>
                            <template slot="no-data">
                              <v-list-item @click="loadModalNewTrailer()">
                                <v-list-item-title>{{
                                  $t(
                                    "components.views.trip.no_offer_assign.modal_assign.create_new_trailer"
                                  )
                                }}</v-list-item-title>
                              </v-list-item>
                            </template>
                          </SelectAutocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="justify-center mt-10 mb-2">
                        <v-btn color="secondary" @click.stop="e1 = 1" depressed>
                          <v-icon small class="mr-1">fa-solid fa-arrow-left</v-icon>
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.previous"
                            )
                          }}
                        </v-btn>
                        <v-btn color="primary" @click="e1 = 3" class="ml-4" depressed :disabled="!validTab2">
                          <v-icon small class="mr-1">fa-solid fa-arrow-right</v-icon>
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.next"
                            )
                          }}
                        </v-btn>
                        <v-btn color="grey lighten-1 white--text" class="ml-4" depressed
                          @click.stop="$emit('closeForm')">
                          <v-icon small size="15" class="mr-1"> fa-solid fa-xmark </v-icon>
                          {{
                            $t(
                              "components.views.trip.offers.transport_company.modal_form_accept.cancel"
                            )
                          }}
                        </v-btn>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-stepper-content>
                <v-stepper-content step="3" class="pa-0">
                  <v-container class="py-8">
                    <v-row class="justify-center">
                      <v-col cols="3">
                        {{
                          $t(
                            "components.views.trip.offers.transport_company.modal_form_accept.driver"
                          )
                        }}:
                      </v-col>
                      <v-col cols="7"> {{ driverNameComputed }} </v-col>
                    </v-row>
                    <v-row class="justify-center">
                      <v-col cols="3">
                        {{
                          $t(
                            "components.views.trip.offers.transport_company.modal_form_accept.vehicle"
                          )
                        }}:
                      </v-col>
                      <v-col cols="7"> {{ vehicle.licensePlate }}</v-col>
                    </v-row>
                    <v-row class="justify-center" v-if="trailer.licensePlate">
                      <v-col cols="3">
                        {{
                          $t(
                            "components.views.trip.offers.transport_company.modal_form_accept.trailer_plate"
                          )
                        }}:
                      </v-col>
                      <v-col cols="7"> {{ trailer.licensePlate }}</v-col>
                    </v-row>
                    <v-row class="justify-center mt-10 mb-2">
                      <v-btn color="secondary" @click="e1 = 2" depressed>
                        <v-icon small class="mr-1">fa-solid fa-arrow-left</v-icon>
                        {{
                          $t(
                            "components.views.trip.offers.transport_company.modal_form_accept.previous"
                          )
                        }}
                      </v-btn>
                      <v-btn color="primary" class="ml-4" depressed @click="confirm()">
                        <v-icon small class="mr-1">fa-solid fa-solid fa-check</v-icon>
                        {{
                          $t(
                            "components.views.trip.offers.transport_company.modal_form_accept.confirm"
                          )
                        }}
                      </v-btn>
                      <v-btn color="grey lighten-1 white--text" class="ml-4" depressed @click.stop="$emit('closeForm')">
                        <v-icon small size="15" class="mr-1"> fa-solid fa-xmark </v-icon>
                        {{
                          $t(
                            "components.views.trip.offers.transport_company.modal_form_accept.cancel"
                          )
                        }}
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-stepper-content>
              </v-col>
            </v-row>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-card-text>
    <v-dialog v-model="dialogDriver" scrollable width="35%" persistent>
      <ModalCreateDriver :idDriver="driverCapture" :idCompany="idCompanyTransporter" @closeForm="onCloseFormDriver()"
        @driverCreated="onDriverCreated" />
    </v-dialog>
    <v-dialog v-model="dialogVehicle" scrollable width="20%" persistent>
      <ModalCreateVehicle :key="index" :idLicensePlate="vehicleCapture" :idCompany="idCompanyTransporter"
        @closeForm="onCloseFormVehicle()" @vehicleCreated="onVehicleCreated" />
    </v-dialog>

    <v-dialog v-model="dialogTrailer" scrollable width="20%" persistent>
      <ModalCreateTrailer :key="index" :idLicensePlate="trailerCapture" :idCompany="idCompanyTransporter"
        @closeForm="onCloseFormTrailer()" @trailerCreated="onTrailerCreated" />
    </v-dialog>
    <!-- Modal de alerta de documentos vencidos del conductor -->
    <v-dialog v-model="dialogDocsAlert" scrollable width="40%" persistent>
      <DriverDocumentsAlertModal :driverName="docsAlertData.driverName" :documents="docsAlertData.documents"
        @close="onCloseDocsAlert" />
    </v-dialog>
    <v-dialog v-model="dialogVehicleDocsAlert" scrollable width="40%" persistent>
      <VehicleDocumentsAlertModal :licensePlate="vehicleDocsAlertData.licensePlate"
        :documents="vehicleDocsAlertData.documents" @close="onCloseVehicleDocsAlert" />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import validate from "@/plugins/validate";
export default {
  components: {
    ModalCreateDriver: () =>
      import(
        /* webpackChunkName: "ModalCreateDriver" */ "@/components/views/Trip/NoOfferAssign/ModalCreateDriver.vue"
      ),
    ModalCreateVehicle: () =>
      import(
        /* webpackChunkName: "ModalCreateVehicle" */ "@/components/views/Trip/NoOfferAssign/ModalCreateVehicle.vue"
      ),
    ModalCreateTrailer: () =>
      import(
        /* webpackChunkName: "ModalCreateTrailer" */ "@/components/views/Trip/NoOfferAssign/ModalCreateTrailer.vue"
      ),
    DriverDocumentsAlertModal: () =>
      import(
        /* webpackChunkName: "DriverDocumentsAlertModal" */ "@/components/views/Trip/modals/DriverDocumentsAlertModal.vue"
      ),
    VehicleDocumentsAlertModal: () =>
      import(
        /* webpackChunkName: "VehicleDocumentsAlertModal" */ "@/components/views/Trip/modals/VehicleDocumentsAlertModal.vue"
      ),
  },
  props: {
    idMonitoringOrder: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 0,
    },
    idCompanyTransporter: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      ...validate,
      dialogDriver: false,
      dialogVehicle: false,
      dialogTrailer: false,
      dialogDocsAlert: false,
      docsAlertData: { driverName: '', documents: [] },
      dialogVehicleDocsAlert: false,
      vehicleDocsAlertData: { licensePlate: '', documents: [] },
      driverCapture: "",
      validTab1: false,
      driverCreate: "",
      validTab2: false,
      driverName: "",
      vehicle: {},
      vehicleCreate: null,
      vehicleCapture: "",
      e1: 1,
      driver: {},
      index: 1,
      trailer: {},
      trailerCreate: null,
      trailerCapture: "",
      allVehicles: [],
    };
  },
  computed: {
    driverNameComputed() {
      return this.driverName !== "" ? this.driverName : "";
    },
    ...mapGetters({
      user: "auth/user",
    }),
    unlockUser() {
      return JSON.parse(this.user);
    },
    urlVehicle() {
      return `/Vehicles`;
    },
    idCompany() {
      return this.unlockUser.user.idCompany;
    },
    filteredTrailers() {
      return this.allVehicles.filter(vehicle => vehicle.idVehicleClass === 15);
    },
  },
  watch: {
    driver(newVal) {
      if (newVal && newVal.idDriver) {
        this.driverName = this.driver.name + " " + this.driver.lastName;
        this.validateDriverCertificate();
      } else {
        this.driverName = "";
      }
    },
    vehicle(newVal) {
      if (newVal && newVal.licensePlate) {
        this.validateVehicleCertificate(newVal.licensePlate);
      }
    },
  },
  mounted() {
    this.loadAllVehicles();
  },
  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    ...mapActions("loader", ["showLoader"]),

    async confirm() {
      this.showLoader({
        show: true,
      });

      let params = {
        idMonitoringOrder: this.idMonitoringOrder,
        idTransporter: this.idCompany,
        amount: parseInt(this.value),
        licensePlate: this.vehicle.licensePlate,
        idDriver: this.driver.idDriver,
        idVehicleTypology: this.vehicle.idVehicleTypology
      };

      // Agregar placa de remolque si está seleccionada
      if (this.trailer && this.trailer.licensePlate) {
        params.trailerPlate = this.trailer.licensePlate;
        params.idTrailerTypology = this.trailer.idVehicleTypology;
      }

      await this.axios
        .post(`Offers/ConfirmedDirectTransportCompany`, params)
        .then(() => {
          this.showSnack({
            text: this.$t(
              "components.views.trip.offers.transport_company.modal_form_accept.description_confirm_success"
            ),
            title: this.$t(
              "components.views.trip.offers.transport_company.modal_form_accept.success"
            ),
            name: "success",
          });
        })
        .catch((error) => {
          this.showSnack({
            text: error.response.data,
            title: "Error",
            name: "error",
          });
        })
        .finally(() => {
          this.showLoader({
            show: false,
          });
          this.$emit("reloadPage");
        });
    },

    onCloseFormDriver() {
      this.dialogDriver = false;
    },

    onOpenFormDriver() {
      this.dialogDriver = true;
    },

    loadModalNewDriver() {
      let driver = this.driverCreate;
      this.driverCapture = driver;
      this.onOpenFormDriver();
    },

    async onDriverCreated(data) {
      if (data) {
        await this.$refs.driver.loadData();
      }
    },

    onOpenFormVehicle() {
      this.dialogVehicle = true;
    },

    onCloseFormVehicle() {
      this.$refs.vehicle.resetFields;
      this.dialogVehicle = false;
    },

    async onVehicleCreated(data) {
      if (data) {
        await this.$refs.vehicle.loadData();
      }
    },

    loadModalNewVehicle() {
      this.index++;
      let vehicle = this.vehicleCreate;
      this.vehicleCapture = vehicle;
      this.onOpenFormVehicle();
    },

    onOpenFormTrailer() {
      this.dialogTrailer = true;
    },

    onCloseFormTrailer() {
      this.dialogTrailer = false;
    },

    async onTrailerCreated(data) {
      if (data) {
        await this.loadAllVehicles();
      }
    },

    loadModalNewTrailer() {
      this.index++;
      let trailer = this.trailerCreate;
      this.trailerCapture = trailer;
      this.onOpenFormTrailer();
    },

    async loadAllVehicles() {
      try {
        const response = await this.axios.get('/Vehicles');
        this.allVehicles = response.data || [];
      } catch (error) {
        console.error('Error loading vehicles:', error);
        this.allVehicles = [];
      }
    },

    async validateDriverCertificate() {
      if (!this.driver || !this.driver.idDriver) return;

      try {
        const response = await this.axios.get(`/Drivers/validateDriver/${this.driver.idDriver}`);
        const validateData = response.data;
        // Validar documentos: vencidos o sin fecha
        const documents = Array.isArray(validateData.documentList) ? validateData.documentList : [];
        if (documents.length > 0) {
          const today = new Date();
          const expiredDocs = documents.filter(doc => {
            if (!doc) return false;
            if (!doc.dateExpiration) return true;
            const exp = new Date(doc.dateExpiration);
            return !isNaN(exp.getTime()) && exp < today;
          });

          const docsWithoutDate = documents.filter(doc => doc && !doc.dateExpiration);

          if (expiredDocs.length > 0) {
            this.showDriverValidationAlert(validateData, expiredDocs);
          } else if (!validateData.certificate && docsWithoutDate.length > 0) {
            this.showDriverValidationAlert(validateData, docsWithoutDate);
          }
        }
      } catch (error) {
        console.error('Error validating driver certificate:', error);
      }
    },

    showDriverValidationAlert(validateData, expiredDocs) {
      try {
        const driverFullName = `${validateData.name} ${validateData.lastName}`;
        this.docsAlertData = { driverName: driverFullName, documents: expiredDocs };
        this.dialogDocsAlert = true;
      } catch (error) {
        console.error('Error in showDriverValidationAlert:', error);
        this.showSnack({ text: 'Error en la validación del conductor', title: 'Error', name: 'error' });
        this.cleanFieldDriver();
      }
    },

    onCloseDocsAlert() {
      this.dialogDocsAlert = false;
      this.cleanFieldDriver();
    },

    formatExpirationDate(expirationDate) {
      if (!expirationDate) return 'Fecha no disponible';

      const date = new Date(expirationDate);
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },

    cleanFieldDriver() {
      this.driver = {};
      this.driverName = "";
      this.driverCreate = "";
    },
    async validateVehicleCertificate(licensePlate) {
      try {
        const { validateVehicleCertificate: validateVehicleCertificateApi } = await import("@/components/validVehicle/validateVehicle.js");
        const result = await validateVehicleCertificateApi(this.axios, licensePlate, { idMonitoringOrder: this.idMonitoringOrder });
        if (result && result.shouldAlert) {
          this.showVehicleValidationAlert(licensePlate, result.documents);
        }
      } catch (error) {
        this.showSnack({ text: 'Error al validar el vehículo', title: 'Error', name: 'error' });
      }
    },
    showVehicleValidationAlert(licensePlate, documents) {
      this.vehicleDocsAlertData = { licensePlate, documents };
      this.dialogVehicleDocsAlert = true;
    },
    onCloseVehicleDocsAlert() {
      this.dialogVehicleDocsAlert = false;
      this.vehicle = {};
      this.vehicleCreate = null;
    },
  },
};
</script>

<style scoped>
@import './ModalFormAcceptStyle.scss';
</style>
